var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriorityHigh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0875 15.2373C6.4125 15.5623 6.9375 15.5623 7.2625 15.2373L10.5042 12.0123L13.7375 15.2457C14.0625 15.5707 14.5875 15.5707 14.9125 15.2457C15.2375 14.9207 15.2375 14.3957 14.9125 14.0707L11.0875 10.2457C10.7625 9.92067 10.2375 9.92067 9.9125 10.2457L6.0875 14.0623C5.7625 14.3873 5.7625 14.9123 6.0875 15.2373Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0875 9.74567C6.4125 10.0707 6.9375 10.0707 7.2625 9.74567L10.5042 6.52067L13.7375 9.754C14.0625 10.079 14.5875 10.079 14.9125 9.754C15.2375 9.429 15.2375 8.904 14.9125 8.579L11.0875 4.754C10.7625 4.429 10.2375 4.429 9.9125 4.754L6.0875 8.57067C5.7625 8.89567 5.7625 9.42067 6.0875 9.74567Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityHigh);
export default __webpack_public_path__ + "static/media/priority_high.e46b1ee66e86f6339b30216a9b32d2fc.svg";
export { ForwardRef as ReactComponent };